// Central registry for edge type strategies

import type { EdgeTypeDefinition } from '@/modules/Edge';

const registry: Record<string, EdgeTypeDefinition> = {};

function registerEdgeType(edgeType: EdgeTypeDefinition): void {
  registry[edgeType.value] = edgeType;
}

function getEdgeType(value: string): EdgeTypeDefinition {
  const edgeType = registry[value];
  if (!edgeType) {
    throw new Error(`Unknown edge type: "${value}"`);
  }
  return edgeType;
}

export { registerEdgeType, getEdgeType };
